module.exports = __webpack_public_path__ + "60bcc398d04b4d6a0da75e4dcc607edd.svg";